/**
 * regionDetection.js
 * Detects user region via IP geolocation (ipapi.co, free, no key required).
 * Result is cached in sessionStorage to avoid repeated calls per session.
 */

const CACHE_KEY = "pista_detected_region";

const COUNTRY_TO_CURRENCY = {
  US: "USD",
  CA: "CAD",
  AU: "AUD",
  UK: "GBP",
  GB: "GBP",
  DE: "EUR",
  FR: "EUR",
  ES: "EUR",
  IT: "EUR",
  NL: "EUR",
  BE: "EUR",
  AT: "EUR",
  PT: "EUR",
  IE: "EUR",
  FI: "EUR",
  GR: "EUR",
};

export function getCurrencyForCountry(countryCode) {
  return COUNTRY_TO_CURRENCY[(countryCode || "").toUpperCase()] || "USD";
}

/**
 * Detect user region from IP.
 * Returns { country: "US", currency: "USD" } (or region-appropriate defaults).
 * Falls back to US/USD on any error.
 */
export async function detectRegion() {
  try {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) {
      return JSON.parse(cached);
    }
  } catch (_) {
    // sessionStorage unavailable — proceed without cache
  }

  try {
    const signal = typeof AbortSignal.timeout === "function" ? AbortSignal.timeout(4000) : undefined;
    const res = await fetch("https://ipapi.co/json/", { signal });
    if (!res.ok) throw new Error("ipapi.co returned non-OK status");
    const data = await res.json();
    const country = (data.country_code || "US").toUpperCase();
    const currency = getCurrencyForCountry(country);
    const region = { country, currency };

    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(region));
    } catch (_) {
      // ignore write failure
    }

    return region;
  } catch (_) {
    return { country: "US", currency: "USD" };
  }
}
